var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15089_456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15089_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 25.4063C14.7083 25.4063 14.4115 25.3542 14.1094 25.25C13.8073 25.1458 13.5417 24.9792 13.3125 24.75L11.1562 22.7813C8.94792 20.7604 6.95312 18.7552 5.17188 16.7656C3.39062 14.776 2.5 12.5833 2.5 10.1875C2.5 8.22917 3.15625 6.59375 4.46875 5.28125C5.78125 3.96875 7.41667 3.3125 9.375 3.3125C10.4792 3.3125 11.5208 3.54688 12.5 4.01563C13.4792 4.48438 14.3125 5.125 15 5.9375C15.6875 5.125 16.5208 4.48438 17.5 4.01563C18.4792 3.54688 19.5208 3.3125 20.625 3.3125C22.5833 3.3125 24.2188 3.96875 25.5313 5.28125C26.8438 6.59375 27.5 8.22917 27.5 10.1875C27.5 12.5833 26.6146 14.7813 24.8438 16.7813C23.0729 18.7813 21.0625 20.7917 18.8125 22.8125L16.6875 24.75C16.4583 24.9792 16.1927 25.1458 15.8906 25.25C15.5885 25.3542 15.2917 25.4063 15 25.4063Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.ea3906587cfac5dc891c1b3dca7c8f0f.svg";
export { ForwardRef as ReactComponent };